/* LE CERCLE — comportement du formulaire d'inscription + defilement vers l'ancre.
 Charge uniquement par le modele page.le-cercle (section Le Cercle — Inscription). */

(function () {
  if (window.__lcSignupBound) return;
  window.__lcSignupBound = true;

  // ?lcdebug=1 dans l'URL : le message d'erreur affiche la cause technique exacte.
  var DEBUG = false;
  try { DEBUG = /[?&]lcdebug=1/.test(window.location.search); } catch (e) {}

  var DEFAULTS = {
    sending: 'Un instant…',
    generic: 'Ça n’a pas marché. Réessaie dans un instant.',
    email: 'Il manque une adresse email valide.',
    first: 'Dis-nous ton prénom.',
    phone: 'Ce numéro ne semble pas valide.'
  };

  function texts(panel) {
    return {
      sending: panel.getAttribute('data-txt-sending') || DEFAULTS.sending,
      generic: panel.getAttribute('data-txt-generic') || DEFAULTS.generic,
      email: panel.getAttribute('data-txt-email') || DEFAULTS.email,
      first: panel.getAttribute('data-txt-first') || DEFAULTS.first,
      phone: panel.getAttribute('data-txt-phone') || DEFAULTS.phone
    };
  }

  function setStatus(panel, message, state) {
    var node = panel.querySelector('[data-lc-status]');
    if (!node) return;
    node.textContent = message || '';
    if (state) node.setAttribute('data-state', state);
    else node.removeAttribute('data-state');
  }

  function looksLikeEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(value);
  }

  function jumpTo(y) {
    try { window.scrollTo({ top: y, behavior: 'instant' }); }
    catch (e) { window.scrollTo(0, y); }
  }

  /* Amene un element au centre de l'ecran. Sur mobile, la fermeture du clavier
     redispose la page apres coup : on repasse donc une seconde fois. */
  function bringIntoView(el) {
    if (!el) return;
    function pass() {
      try {
        var box = el.getBoundingClientRect();
        var margin = Math.max(24, (window.innerHeight - box.height) / 2);
        jumpTo(Math.max(0, Math.round(box.top + (window.pageYOffset || 0) - margin)));
      } catch (e) {}
    }
    pass();
    window.setTimeout(pass, 140);
    window.setTimeout(pass, 460);
  }

  function revealDone(panel) {
    var live = panel.querySelector('[data-lc-live]');
    var tpl = panel.querySelector('[data-lc-done]');
    if (tpl && tpl.content && live) {
      live.replaceWith(tpl.content.cloneNode(true));
    } else if (live) {
      live.style.display = 'none';
    }
    bringIntoView(panel.querySelector('.lc-done') || panel);
  }

  function send(panel) {
    var form = panel.querySelector('[data-lc-form]');
    if (!form || panel.dataset.lcBusy === '1') return;

    /* Mobile : le clavier masque le bouton, le message d'erreur et la
       confirmation. On le ferme des le clic — c'est aussi le premier retour
       visible que le clic a bien ete pris en compte. */
    try {
      var focused = document.activeElement;
      if (focused && focused.blur && form.contains(focused)) focused.blur();
    } catch (e) {}

    var emailField = form.querySelector('input[name="email"]');
    var firstField = form.querySelector('input[name="first_name"]');
    var trap = form.querySelector('input[name="societe"]');
    var button = form.querySelector('[data-lc-submit]');
    var t = texts(panel);

    if (!emailField) return;
    if (trap && trap.value) return; // robot : on ne fait rien

    var email = (emailField.value || '').trim();
    var firstName = firstField ? (firstField.value || '').trim() : '';

    emailField.removeAttribute('aria-invalid');
    if (firstField) firstField.removeAttribute('aria-invalid');

    if (firstField && firstField.hasAttribute('required') && !firstName) {
      firstField.setAttribute('aria-invalid', 'true');
      setStatus(panel, t.first, 'error');
      bringIntoView(panel.querySelector('[data-lc-status]'));
      return;
    }

    if (!looksLikeEmail(email)) {
      emailField.setAttribute('aria-invalid', 'true');
      setStatus(panel, t.email, 'error');
      bringIntoView(panel.querySelector('[data-lc-status]'));
      return;
    }

    var attributes = { email: email, subscriptions: { email: { marketing: { consent: 'SUBSCRIBED' } } } };
    if (firstName) attributes.first_name = firstName;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: attributes } },
          custom_source: panel.dataset.source || 'Le Cercle'
        },
        relationships: { list: { data: { type: 'list', id: panel.dataset.list } } }
      }
    };

    panel.dataset.lcBusy = '1';
    var sentAt = Date.now();
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = t.sending; }
    setStatus(panel, '');

    var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(panel.dataset.company || '');
    var revision = panel.dataset.revision || '2026-07-15';
    var body = JSON.stringify(payload);

    function fail(detail) {
      if (window.console) console.warn('[Le Cercle] ' + detail);
      panel.dataset.lcBusy = '0';
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = button.getAttribute('data-label'); }
      setStatus(panel, DEBUG ? detail : t.generic, 'error');
      bringIntoView(panel.querySelector('[data-lc-status]'));
    }

    function ok() {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        try { window.klaviyo.identify({ $email: email, $first_name: firstName }); } catch (e) {}
      }
      setStatus(panel, '');
      /* Une reponse trop rapide donne l'impression que rien ne s'est passe :
         on laisse l'etat « envoi » visible au moins 450 ms. */
      var reste = Math.max(0, 450 - (Date.now() - sentAt));
      window.setTimeout(function () {
        if (panel.dataset.step2 === '1' && panel.querySelector('[data-lc-step2]')) showStep2(panel, email, firstName);
        else revealDone(panel);
      }, reste);
    }

    // Secours : certains bloqueurs de pub neutralisent fetch mais pas XHR.
    function viaXhr(why) {
      if (window.console) console.warn('[Le Cercle] bascule XHR (' + why + ')');
      try {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint, true);
        xhr.setRequestHeader('revision', revision);
        xhr.setRequestHeader('content-type', 'application/json');
        xhr.onload = function () {
          if (xhr.status === 202 || (xhr.status >= 200 && xhr.status < 300)) ok();
          else fail('XHR ' + xhr.status + ' : ' + (xhr.responseText || '').slice(0, 160));
        };
        xhr.onerror = function () { fail('requete bloquee (fetch : ' + why + ' / XHR : erreur reseau). Un bloqueur de pub ou une extension empeche l\'appel a Klaviyo.'); };
        xhr.send(body);
      } catch (e) {
        fail('requete impossible : ' + why + ' / ' + (e && e.message ? e.message : e));
      }
    }

    if (typeof window.fetch !== 'function') { viaXhr('fetch indisponible'); return; }

    window.fetch(endpoint, {
      method: 'POST',
      headers: { 'revision': revision, 'content-type': 'application/json' },
      body: body
    }).then(function (response) {
      if (response.status === 202 || response.ok) { ok(); return; }
      return response.text().then(function (text) { fail('Klaviyo ' + response.status + ' : ' + (text || '').slice(0, 160)); });
    }).catch(function (error) {
      viaXhr(error && error.message ? error.message : String(error));
    });
  }

  /* ---------- Etape 2 : le numero de telephone ----------
     L'email est deja enregistre a ce stade. L'etape 2 est un second appel,
     independant : si elle echoue ou si le visiteur la passe, le lead reste
     acquis. C'est tout l'interet de ne pas tout envoyer en un seul coup. */

  function setStatus2(panel, message, state) {
    var node = panel.querySelector('[data-lc-status2]');
    if (!node) return;
    node.textContent = message || '';
    if (state) node.setAttribute('data-state', state);
    else node.removeAttribute('data-state');
  }

  /* Ramene une saisie libre au format E.164 attendu par Klaviyo.
     Un numero commencant par 0 prend l'indicatif regle dans l'editeur
     (262 pour La Reunion, 33 pour la metropole). */
  function normalisePhone(raw, country) {
    var cc = String(country || '262');
    var v = String(raw || '').replace(/[\s.\-()\/]/g, '');
    if (!v) return '';
    if (v.indexOf('00') === 0) v = '+' + v.slice(2);

    if (v.charAt(0) !== '+') {
      var nat = v.charAt(0) === '0' ? v.slice(1) : v;
      // Numero deja saisi avec son indicatif mais sans le +
      if (nat.indexOf(cc) === 0 && nat.length === cc.length + 9) nat = nat.slice(cc.length);
      /* A La Reunion les mobiles sont en 692 / 693. Un 06 ou 07 qui n'en est pas
         un vient de metropole : on lui met +33 plutot qu'un +262 invalide. */
      if (cc === '262' && /^[67]/.test(nat) && !/^69[23]/.test(nat)) cc = '33';
      v = '+' + cc + nat;
    }

    if (!/^\+[1-9]\d{7,14}$/.test(v)) return '';
    // Sur les indicatifs qu'on connait, la partie nationale fait exactement 9 chiffres.
    if ((v.indexOf('+262') === 0 && v.length !== 13) || (v.indexOf('+33') === 0 && v.length !== 12)) return '';
    return v;
  }

  function showStep2(panel, email, firstName) {
    var step1 = panel.querySelector('[data-lc-step1]');
    var step2 = panel.querySelector('[data-lc-step2]');
    if (!step2) { revealDone(panel); return; }
    panel.dataset.lcEmail = email || '';
    panel.dataset.lcFirst = firstName || '';
    panel.dataset.lcBusy = '0';
    if (step1) step1.hidden = true;
    step2.hidden = false;
    bringIntoView(step2);
    var field = step2.querySelector('input[name="phone"]');
    if (field) { try { field.focus({ preventScroll: true }); } catch (e) {} }
  }

  function sendPhone(panel) {
    var step2 = panel.querySelector('[data-lc-step2]');
    if (!step2 || panel.dataset.lcBusy === '1') return;

    try {
      var focused = document.activeElement;
      if (focused && focused.blur && step2.contains(focused)) focused.blur();
    } catch (e) {}

    var field = step2.querySelector('input[name="phone"]');
    var button = step2.querySelector('[data-lc-submit2]');
    var t = texts(panel);
    if (!field) { revealDone(panel); return; }

    field.removeAttribute('aria-invalid');
    var phone = normalisePhone(field.value, panel.dataset.phoneCountry);
    if (!phone) {
      field.setAttribute('aria-invalid', 'true');
      setStatus2(panel, t.phone, 'error');
      bringIntoView(step2);
      return;
    }

    /* Le consentement WhatsApp s'enregistre bien dans Klaviyo (canal actif sur
       le compte). Le SMS, non : le compte n'a pas le canal, Klaviyo repond 202
       et ecarte le bloc en silence. On ecrit donc aussi la trace en proprietes
       de profil, pour pouvoir rejouer l'abonnement SMS le jour ou il sera
       active, avec une date de consentement verifiable. */
    var attributes = {
      email: panel.dataset.lcEmail,
      phone_number: phone,
      properties: {
        'Consentement WhatsApp': 'OUI',
        'Consentement SMS': 'OUI',
        'Consentement messages - date': new Date().toISOString(),
        'Consentement messages - source': panel.dataset.source || 'Le Cercle'
      },
      subscriptions: {
        email: { marketing: { consent: 'SUBSCRIBED' } },
        whatsapp: { marketing: { consent: 'SUBSCRIBED' } },
        sms: { marketing: { consent: 'SUBSCRIBED' } }
      }
    };
    if (panel.dataset.lcFirst) attributes.first_name = panel.dataset.lcFirst;

    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          profile: { data: { type: 'profile', attributes: attributes } },
          custom_source: panel.dataset.source || 'Le Cercle'
        },
        relationships: { list: { data: { type: 'list', id: panel.dataset.list } } }
      }
    };

    panel.dataset.lcBusy = '1';
    var sentAt = Date.now();
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); button.textContent = t.sending; }
    setStatus2(panel, '');

    var endpoint = 'https://a.klaviyo.com/client/subscriptions/?company_id=' + encodeURIComponent(panel.dataset.company || '');
    var revision = panel.dataset.revision || '2026-07-15';
    var body = JSON.stringify(payload);

    function fail2(detail) {
      if (window.console) console.warn('[Le Cercle] etape 2 : ' + detail);
      panel.dataset.lcBusy = '0';
      if (button) { button.disabled = false; button.removeAttribute('aria-busy'); button.textContent = button.getAttribute('data-label'); }
      setStatus2(panel, DEBUG ? detail : t.generic, 'error');
      bringIntoView(step2);
    }

    function ok2() {
      if (window.klaviyo && typeof window.klaviyo.identify === 'function') {
        try { window.klaviyo.identify({ $email: panel.dataset.lcEmail, $phone_number: phone }); } catch (e) {}
      }
      setStatus2(panel, '');
      var reste = Math.max(0, 450 - (Date.now() - sentAt));
      window.setTimeout(function () { revealDone(panel); }, reste);
    }

    function viaXhr2(why) {
      try {
        var xhr = new XMLHttpRequest();
        xhr.open('POST', endpoint, true);
        xhr.setRequestHeader('revision', revision);
        xhr.setRequestHeader('content-type', 'application/json');
        xhr.onload = function () {
          if (xhr.status === 202 || (xhr.status >= 200 && xhr.status < 300)) ok2();
          else fail2('XHR ' + xhr.status + ' : ' + (xhr.responseText || '').slice(0, 160));
        };
        xhr.onerror = function () { fail2('requete bloquee (fetch : ' + why + ' / XHR : erreur reseau).'); };
        xhr.send(body);
      } catch (e) {
        fail2('requete impossible : ' + why + ' / ' + (e && e.message ? e.message : e));
      }
    }

    /* Seconde liste : la liste WhatsApp du site. Envoi en parallele, volontairement
       sans attendre sa reponse — le lead est deja dans la liste principale, et la
       confirmation ne doit pas dependre d'un second aller-retour. */
    var listePhone = (panel.dataset.listPhone || '').trim();
    if (listePhone && listePhone !== panel.dataset.list && typeof window.fetch === 'function') {
      try {
        var payload2 = JSON.parse(body);
        payload2.data.relationships.list.data.id = listePhone;
        window.fetch(endpoint, {
          method: 'POST',
          headers: { 'revision': revision, 'content-type': 'application/json' },
          body: JSON.stringify(payload2)
        }).then(function (r) {
          if (!(r.status === 202 || r.ok) && window.console) console.warn('[Le Cercle] liste secondaire : ' + r.status);
        }).catch(function (e) {
          if (window.console) console.warn('[Le Cercle] liste secondaire injoignable : ' + (e && e.message ? e.message : e));
        });
      } catch (e) {
        if (window.console) console.warn('[Le Cercle] liste secondaire ignoree : ' + (e && e.message ? e.message : e));
      }
    }

    if (typeof window.fetch !== 'function') { viaXhr2('fetch indisponible'); return; }

    window.fetch(endpoint, {
      method: 'POST',
      headers: { 'revision': revision, 'content-type': 'application/json' },
      body: body
    }).then(function (response) {
      if (response.status === 202 || response.ok) { ok2(); return; }
      return response.text().then(function (text) { fail2('Klaviyo ' + response.status + ' : ' + (text || '').slice(0, 160)); });
    }).catch(function (error) {
      viaXhr2(error && error.message ? error.message : String(error));
    });
  }

  function panelOf(node) {
    return node && node.closest ? node.closest('[data-lc-signup]') : null;
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-lc-form]')) return;
    event.preventDefault();
    var panel = panelOf(form);
    if (panel) send(panel);
  }, true);

  // Filet : si le theme avale l'evenement submit, le clic suffit.
  document.addEventListener('click', function (event) {
    var button = event.target && event.target.closest ? event.target.closest('[data-lc-submit]') : null;
    if (!button) return;
    var panel = panelOf(button);
    if (!panel) return;
    event.preventDefault();
    send(panel);
  }, true);

  // Entree dans un champ = envoi, meme si le theme intercepte le submit natif.
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var field = event.target && event.target.closest ? event.target.closest('[data-lc-form] .lc-input') : null;
    if (!field) return;
    var panel = panelOf(field);
    if (!panel) return;
    event.preventDefault();
    send(panel);
  }, true);

  // Etape 2 : memes trois portes d'entree que l'etape 1.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (!form || !form.matches || !form.matches('[data-lc-form2]')) return;
    event.preventDefault();
    var panel = panelOf(form);
    if (panel) sendPhone(panel);
  }, true);

  document.addEventListener('click', function (event) {
    if (!event.target || !event.target.closest) return;
    var skip = event.target.closest('[data-lc-skip]');
    if (skip) {
      var p1 = panelOf(skip);
      if (p1) { event.preventDefault(); revealDone(p1); }
      return;
    }
    var button = event.target.closest('[data-lc-submit2]');
    if (!button) return;
    var panel = panelOf(button);
    if (!panel) return;
    event.preventDefault();
    sendPhone(panel);
  }, true);

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Enter') return;
    var field = event.target && event.target.closest ? event.target.closest('[data-lc-form2] .lc-input') : null;
    if (!field) return;
    var panel = panelOf(field);
    if (!panel) return;
    event.preventDefault();
    sendPhone(panel);
  }, true);
})();

(function () {
  if (window.__lcAnchorBound) return;
  window.__lcAnchorBound = true;

  function jump(y) {
    try { window.scrollTo({ top: y, behavior: 'instant' }); }
    catch (e) { window.scrollTo(0, y); }
  }

  function destination(el) {
    var margin = parseFloat(window.getComputedStyle(el).scrollMarginTop);
    if (isNaN(margin)) margin = 0;
    var top = el.getBoundingClientRect().top + (window.pageYOffset || 0);
    return Math.max(0, Math.round(top - margin));
  }

  function glide(el) {
    var end = destination(el);
    var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduce || document.hidden) { jump(end); return; }

    var start = window.pageYOffset || 0;
    var delta = end - start;
    if (Math.abs(delta) < 2) return;

    var duration = Math.min(900, Math.max(320, Math.abs(delta) * 0.5));
    var startedAt = null;

    function frame(now) {
      if (startedAt === null) startedAt = now;
      var p = Math.min(1, (now - startedAt) / duration);
      var eased = p < 0.5 ? 4 * p * p * p : 1 - Math.pow(-2 * p + 2, 3) / 2;
      jump(start + delta * eased);
      if (p < 1) window.requestAnimationFrame(frame);
    }

    window.requestAnimationFrame(frame);

    window.setTimeout(function () {
      if (Math.abs((window.pageYOffset || 0) - destination(el)) > 4) jump(destination(el));
    }, duration + 160);
  }

  document.addEventListener('click', function (event) {
    var link = event.target && event.target.closest ? event.target.closest('.lc a[href^="#"]') : null;
    if (!link) return;
    var id = link.getAttribute('href').slice(1);
    var target = id ? document.getElementById(id) : null;
    if (!target) return;
    event.preventDefault();
    glide(target);
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', '#' + id);
    }
  }, true);

  window.addEventListener('load', function () {
    var id = window.location.hash.slice(1);
    var target = id ? document.getElementById(id) : null;
    if (target) window.setTimeout(function () { jump(destination(target)); }, 160);
  });
})();